import type { HammerGame } from '../../minigames/HammerGame';
import { AttemptGrade } from '../../minigames/MiniGame';
import { COLORS, drawBurst, drawGradeLabel } from './paint';

/**
 * What lies over the 3D hammer scene (HammerStage3D) on the transparent 2D canvas: sparks at the nail head on a hit,
 * wood chips on a miss, a flash on the perfect strike and the verdict as a big word.
 */
export function drawHammerEffects(ctx: CanvasRenderingContext2D, w: number, h: number, game: HammerGame, nail: { x: number; y: number }): void {
  const age = game.secondsSinceGrade;
  const last = game.strikes[game.strikes.length - 1];
  if (!last || age > 1.2) return;
  const seed = game.strikes.length * 7919;
  if (last.grade === AttemptGrade.Perfect) {
    if (age < 0.35) {
      const k = age / 0.35;
      const r = h * 0.18 * (0.4 + k);
      const g = ctx.createRadialGradient(nail.x, nail.y, 0, nail.x, nail.y, r);
      g.addColorStop(0, `rgba(255, 250, 215, ${0.85 * (1 - k)})`);
      g.addColorStop(0.4, `rgba(255, 200, 80, ${0.4 * (1 - k)})`);
      g.addColorStop(1, 'rgba(255, 200, 80, 0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(nail.x, nail.y, r, 0, Math.PI * 2);
      ctx.fill();
    }
    drawBurst(ctx, { x: nail.x, y: nail.y, count: 34, speed: h * 1.3, gravity: h * 2.6, life: 0.75, colors: ['#fff7c2', COLORS.gold, '#ffb12b'], spread: Math.PI * 0.62, size: 2.2, seed, streaks: true }, age);
  } else if (last.grade === AttemptGrade.Good) {
    drawBurst(ctx, { x: nail.x, y: nail.y, count: 12, speed: h * 0.9, gravity: h * 2.6, life: 0.5, colors: ['#ffe9a8', '#ffb12b'], spread: Math.PI * 0.5, size: 1.8, seed, streaks: true }, age);
  } else if (last.x !== null) {
    drawBurst(ctx, { x: nail.x + (last.x > 0 ? 1 : -1) * w * 0.12, y: nail.y + h * 0.06, count: 16, speed: h * 0.75, gravity: h * 3.2, life: 0.7, colors: ['#c9925a', '#a8723f', '#e3b682'], spread: Math.PI * 0.55, size: 3, seed, streaks: false }, age);
  }
  const word = last.grade === AttemptGrade.Good ? 'SEITLICH +10 %' : last.x === null ? 'ZU SPÄT' : undefined;
  drawGradeLabel(ctx, last.grade, age, w / 2, h * 0.18, Math.round(h * 0.11), word);
}
